import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "mask", "namespace"];
import React, { forwardRef } from 'react';
import InputMask from 'react-input-mask';
import classNames from 'classnames/bind';
import { getMethodsForTestId } from "../../utils/getMethodsForTestId";
import styles from './InputBase.css';
var cx = classNames.bind(styles);
export var InputBase = /*#__PURE__*/forwardRef(function InputBase(_ref, ref) {
  var className = _ref.className,
      mask = _ref.mask,
      namespace = _ref.namespace,
      props = _objectWithoutProperties(_ref, _excluded);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'inputBase'),
      getTestId = _getMethodsForTestId.getTestId;

  return mask ? /*#__PURE__*/React.createElement(InputMask, _extends({}, props, getTestId(), {
    inputRef: ref,
    mask: mask,
    className: cx('root', className),
    capture: undefined
  })) : /*#__PURE__*/React.createElement("input", _extends({}, props, getTestId(), {
    ref: ref,
    className: cx('root', className)
  }));
});